module.exports = __webpack_public_path__ + "static-H5/img/icon_empty.fcf2768f.png";